import { render } from "./Perfil.vue?vue&type=template&id=51f88584"
import script from "./Perfil.vue?vue&type=script&lang=js"
export * from "./Perfil.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\maike\\OneDrive\\Documents\\Projetos\\BPA Channel\\bpa-channnel-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__